export default __webpack_public_path__ + "static/media/carousel-slide-2.1c050e47.jpg";